import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=634d806e&scoped=true&"
import script from "./UploadButton.vue?vue&type=script&lang=js&"
export * from "./UploadButton.vue?vue&type=script&lang=js&"
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=634d806e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d806e",
  null
  
)

export default component.exports